import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { PrinterQueueTypes } from "../printerQueueTypes"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    subtitle: {
        fontSize: ".75rem",
        color: tailwindPalette.gray[400],
    },
}))

export function DeviceCell({ data }: { data: PrinterQueueTypes }) {
    const { device, deviceGroup } = data
    const { classes } = useStyles()

    return (
        <Stack direction="column" spacing={1}>
            <Typography>{device.name}</Typography>
            <Typography className={classes.subtitle}>
                {deviceGroup.id} -
                <LocalizedStrict id="support-printer-queue-table-device-group">
                    <>Group:</>
                </LocalizedStrict>
                {deviceGroup.name}
            </Typography>
        </Stack>
    )
}
